import { Reducer } from "../../lib/redux";
import { extend } from "../../utils/vanilla";
import { SuspiciousLogsSentActions } from "./actions";
import { ISuspiciousLogsSent, SuspiciousLogsSentActionTypes } from "./types";

export const defaultSuspiciousLogSent: ISuspiciousLogsSent = {
    version: "",
    data: []
};

export let suspiciousLogsSent: Reducer<ISuspiciousLogsSent, SuspiciousLogsSentActions> = (state: ISuspiciousLogsSent = defaultSuspiciousLogSent, action): ISuspiciousLogsSent => {
    switch (action.type) {
        case SuspiciousLogsSentActionTypes.SET_SUSPICIOUS_LOGS_SENT:
            return extend(true, {}, action.payload);
        case SuspiciousLogsSentActionTypes.CLEAR_SUSPICIOUS_LOGS_SENT:
            return extend(true, {}, defaultSuspiciousLogSent);
        default:
            return state;
    }
};
